
import { HTMLAttributes, ReactElement } from "react";
interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
    myStyle?: string;
}
function ArrowDown({ color, myStyle }: Props): ReactElement {
    return (
        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg" className={myStyle ? myStyle : ""}>
            <path d="M14.1106 5.59375L9.49229 9.66875C8.94687 10.15 8.05438 10.15 7.50896 9.66875L2.89062 5.59375" stroke={color? color : "black" }strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
export default ArrowDown;